import type { RouteRecordRaw } from "vue-router";

export const worksheetWizardRoutes: RouteRecordRaw[] = [
  // Legacy path - redirects to canonical /worksheet/wizard/info
  {
    path: "/worksheet_wizard/info",
    redirect: { name: "worksheet_wizard-info" },
  },
];
